import React from 'react'
import { Block, BodyLarge, Body, Row } from '@thesisedu/web/dist'
import { Col } from 'antd'
import { Container, LargeH1 } from '../components/styled'
import { ContactForm } from '../components/ContactForm'
import { SEO } from '../components/SEO'
import { SupportWidget } from '../components/support/SupportWidget'

export const Contact: React.FC = () => {
  return (
    <Container>
      <SEO title={'Contact Us'} />
      <Block marginTop={'@size-section-md'} marginBottom={'@size-xxl'}>
        <LargeH1 isBlock={false}>Contact Us</LargeH1>
      </Block>
      <SupportWidget hideTitle />
      <Block marginTop={'@size-xl'}>
        <Row>
          <Col xs={24} md={8}>
            <BodyLarge isBlock style={{ lineHeight: 1.7 }}>
              <strong>Where every child is exceptional.</strong> Prodigies Academy provides
              engaging, interactive, <strong>standards-based,</strong> customizable curriculum for{' '}
              <strong>K-5 General Music Education.</strong> Prodigies Academy{' '}
              <strong>integrates with all leading LMS providers</strong> and works on all browsers
              and devices.
            </BodyLarge>
            <Body isBlock style={{ lineHeight: 1.6 }}>
              If you would like to get in touch, simply use this form and a member of our sales team
              will reach out as soon as possible.
            </Body>
            <Body isBlock>
              Thanks!
              <br />
              The Prodigies Academy Team
            </Body>
          </Col>
          <Col xs={24} md={16}>
            <ContactForm />
          </Col>
        </Row>
      </Block>
    </Container>
  )
}

export default Contact
